/* eslint-disable  */
import React from "react";
import "./DashboardSkeleton.css";

const sk = (extra = "") => `skel ${extra}`.trim();

function DashboardSkeleton() {
  return (
    <div className="dash-skeleton" aria-busy="true" aria-label="Loading dashboard">
      {/* Module Cards */}
      <div className="module-cards">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="dash-skeleton__card">
            <div className="dash-skeleton__card-header">
              <span className={sk("skel--icon")} />
              <span className={sk("skel--dot")} />
            </div>
            <span className={sk("skel--title")} />
            <div className="dash-skeleton__card-stats">
              <span className={sk("skel--stat")} />
              <span className={sk("skel--stat")} />
            </div>
          </div>
        ))}
      </div>

      {/* Stats Overview */}
      <div className="stats-grid">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="dash-skeleton__stat-card">
            <span className={sk("skel--icon")} />
            <div className="dash-skeleton__stat-content">
              <span className={sk("skel--label")} />
              <span className={sk("skel--value")} />
            </div>
          </div>
        ))}
      </div>

      {/* Loan Statistics Section */}
      <section className="dash-skeleton__panel">
        <div className="dash-skeleton__panel-header">
          <span className={sk("skel--heading")} />
          <span className={sk("skel--pill")} />
        </div>
        <div className="dash-skeleton__split">
          <div className="dash-skeleton__pie">
            <span className={sk("skel--circle")} />
            <div className="dash-skeleton__legend">
              {[0, 1, 2, 3, 4, 5].map((i) => (
                <span key={i} className={sk("skel--legend")} />
              ))}
            </div>
          </div>
          <div className="dash-skeleton__bars">
            {[0, 1, 2, 3, 4, 5, 6].map((i) => (
              <span
                key={i}
                className={sk("skel--bar")}
                style={{ height: `${30 + ((i * 37) % 70)}%` }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Region Statistics */}
      <section className="dash-skeleton__panel">
        <span className={sk("skel--heading")} />
        <div className="dash-skeleton__region-grid">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="dash-skeleton__region-card">
              <span className={sk("skel--bar-thin")} />
              <div className="dash-skeleton__stat-content">
                <span className={sk("skel--label")} />
                <span className={sk("skel--value-sm")} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default DashboardSkeleton;
